import React from "react";
import { withRouter } from "react-router-dom";
import cx from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import Spinner from "../AtutaSpinner/Spinner";
import SimpleAlert from "../../components/AtutaAlerts/CustomAlerts";
import wizardStyle from "assets/jss/material-dashboard-pro-react/components/wizardStyle.js";
import AuthApi from "../../api_calls/AuthApi";
import StorageKeys from "constants/storageKeys";

class Wizard extends React.Component {
  constructor(props) {
    super(props);
    var width;
    if (this.props.steps.length === 1) {
      width = "100%";
    } else {
      if (window.innerWidth < 600) {
        if (this.props.steps.length !== 3) {
          width = "50%";
        } else {
          width = 100 / 3 + "%";
        }
      } else {
        if (this.props.steps.length === 2) {
          width = "50%";
        } else {
          width = 100 / 3 + "%";
        }
      }
    }
    this.state = {
      currentStep: 0,
      color: this.props.color,
      nextButton: this.props.steps.length > 1 ? true : false,
      previousButton: false,
      finishButton: this.props.steps.length === 1 ? true : false,
      width: width,
      movingTabStyle: { transition: "transform 0s" },
      allStates: {},
      alert: null,
      loading: false,
      alertMessage: null,
    };
    this.navigationStepChange = this.navigationStepChange.bind(this);
    this.refreshAnimation = this.refreshAnimation.bind(this);
    this.previousButtonClick = this.previousButtonClick.bind(this);
    this.finishButtonClick = this.finishButtonClick.bind(this);
    this.updateWidth = this.updateWidth.bind(this);
  }

  wizard = React.createRef();

  componentDidMount() {
    this.refreshAnimation(0);
    window.addEventListener("resize", this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }

  updateWidth() {
    this.refreshAnimation(this.state.currentStep);
  }

  navigationStepChange(key) {
    if (this.props.steps) {
      var validationState = true;
      if (key > this.state.currentStep) {
        for (var i = this.state.currentStep; i < key; i++) {
          if (this[this.props.steps[i].stepId].sendState !== undefined) {
            this.setState({
              allStates: {
                ...this.state.allStates,
                [this.props.steps[i].stepId]: this[
                  this.props.steps[i].stepId
                ].sendState(),
              },
            });
          }
          if (
            this[this.props.steps[i].stepId].isValidated !== undefined &&
            this[this.props.steps[i].stepId].isValidated() === false
          ) {
            validationState = false;
            break;
          }
        }
      }
      if (validationState) {
        this.setState({
          currentStep: key,
          nextButton: this.props.steps.length > key + 1 ? true : false,
          previousButton: key > 0 ? true : false,
          finishButton: this.props.steps.length === key + 1 ? true : false,
        });
        this.refreshAnimation(key);
      }
    }
  }

  nextButtonClick() {
    const stepId = this.props.steps[this.state.currentStep].stepId;
    const stepRef = this[stepId];

    if (!stepRef || !stepRef.sendState) return;

    const newState = stepRef.sendState();
    const isValid = stepRef.validateBeforeNext
      ? stepRef.validateBeforeNext()
      : true;

    if (!isValid) {
      this.setState({ loading: false });
      return;
    }

    this.setState(
      {
        allStates: {
          ...this.state.allStates,
          [stepId]: newState,
        },
      },
      () => {
        const key = this.state.currentStep + 1;
        this.setState({
          currentStep: key,
          nextButton: this.props.steps.length > key + 1,
          previousButton: key > 0,
          finishButton: this.props.steps.length === key + 1,
        });
        this.refreshAnimation(key);
      }
    );
  }

  previousButtonClick() {
    if (
      this[this.props.steps[this.state.currentStep].stepId].sendState !==
      undefined
    ) {
      this.setState({
        allStates: {
          ...this.state.allStates,
          [this.props.steps[this.state.currentStep].stepId]: this[
            this.props.steps[this.state.currentStep].stepId
          ].sendState(),
        },
      });
    }
    var key = this.state.currentStep - 1;
    if (key >= 0) {
      this.setState({
        currentStep: key,
        nextButton: this.props.steps.length > key + 1 ? true : false,
        previousButton: key > 0 ? true : false,
        finishButton: this.props.steps.length === key + 1 ? true : false,
      });
      this.refreshAnimation(key);
    }
  }

  async finishButtonClick() {
    this.setState({ loading: true });
    const lastStepId = this.props.steps[this.state.currentStep].stepId;
    const lastStepRef = this[lastStepId];

    if (
      lastStepRef &&
      lastStepRef.validateBeforeNext &&
      !lastStepRef.validateBeforeNext()
    ) {
      this.setState({ loading: false });
      return;
    }

    this.setState(
      (prevState) => ({
        allStates: {
          ...prevState.allStates,
          [lastStepId]: lastStepRef?.sendState ? lastStepRef.sendState() : {},
        },
      }),
      async () => {
        const formData = {
          firstName: this.state.allStates.about?.firstName || "",
          otherNames: this.state.allStates.about?.otherNames || "",
          pseudoName: this.state.allStates.about?.nickname || "",
          upline: this.state.allStates.about?.referralCode || "",
          dateOfBirth: `${this.state.allStates.about?.dobDay || ""}-${
            this.state.allStates.about?.dobMonth || ""
          }-${this.state.allStates.about?.dobYear || ""}`,
          gender: this.state.allStates.account?.gender || "",
          email: this.state.allStates.account?.email || "",
          phoneNumber: this.state.allStates.account?.phoneNumber || "",
          country: this.state.allStates.account?.country || "",
          area: this.state.allStates.account?.region || "",
          interestedIn: this.state.allStates.address?.interested_in || "FEMALE",
          interestedInMinAge: this.state.allStates.address?.minAge
            ? String(this.state.allStates.address.minAge)
            : "",
          interestedInMaxAge: this.state.allStates.address?.maxAge
            ? String(this.state.allStates.address.maxAge)
            : "",
          password: this.state.allStates.address?.password || "",
        };

        try {
          const response = await AuthApi.signUp(formData);

          if (formData.email)
            localStorage.setItem(StorageKeys.SIGNUP_EMAIL, formData.email);

          const apiMessage =
            response?.data?.data?.message || response?.data?.message;

          if (apiMessage === "upline_does_not_exist") {
            this.setState({
              alertMessage:
                "Referral code does not exist. Please check and try again.",
              loading: false,
            });
            return;
          }

          if (apiMessage === "user_exists") {
            this.setState({
              alertMessage:
                "The email or phone number is already in use. Please use a different one.",
              loading: false,
            });
            return;
          }

          if (apiMessage === "pseudo_name_exists") {
            this.setState({
              alertMessage:
                "That nickname is already taken. Please choose another.",
              loading: false,
            });
            return;
          }

          if (response.data.status === "fail" && apiMessage) {
            this.setState({
              alertMessage: apiMessage.replace(/_/g, " "),
              loading: false,
            });
            return;
          }

          this.setState({ loading: false });
          this.props.history.push("/auth/register-success");

          if (this.props.finishButtonClick) {
            this.props.finishButtonClick(response);
          }
        } catch (error) {
          this.setState({ loading: false });
          this.setState({
            alertMessage: "Signup failed. Try again.",
          });
        }
      }
    );
  }

  refreshAnimation(index) {
    var total = this.props.steps.length;
    var li_width = 100 / total;
    var total_steps = this.props.steps.length;
    var move_distance =
      this.wizard.current.children[0].offsetWidth / total_steps;
    var index_temp = index;
    var vertical_level = 0;

    var mobile_device = window.innerWidth < 600 && total > 3;

    if (mobile_device) {
      move_distance = this.wizard.current.children[0].offsetWidth / 2;
      index_temp = index % 2;
      li_width = 50;
    }

    this.setState({ width: li_width + "%" });

    var step_width = move_distance;
    move_distance = move_distance * index_temp;

    var current = index + 1;

    if (current === 1 || (mobile_device && index % 2 === 0)) {
      move_distance -= 8;
    } else if (current === total_steps || (mobile_device && index % 2 === 1)) {
      move_distance += 8;
    }

    if (mobile_device) {
      vertical_level = parseInt(index / 2, 10) * 38;
    }

    var movingTabStyle = {
      width: step_width,
      transform:
        "translate3d(" + move_distance + "px, " + vertical_level + "px, 0)",
      transition: "all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)",
    };
    this.setState({ movingTabStyle });
  }

  render() {
    const { classes, title, subtitle, color, steps } = this.props;
    return (
      <div className={classes.wizardContainer} ref={this.wizard}>
        <Card className={classes.card}>
          <div className={classes.wizardHeader}>
            <h3 className={classes.title}>{title}</h3>
            <h5 className={classes.subtitle}>{subtitle}</h5>
          </div>

          {this.state.loading && (
            <div className="spinner-wrapper">
              <Spinner />
            </div>
          )}

          {this.state.alertMessage && (
            <SimpleAlert
              message={this.state.alertMessage}
              onClose={() => this.setState({ alertMessage: null })}
            />
          )}

          <div className={classes.wizardNavigation}>
            <ul className={classes.nav}>
              {steps.map((prop, key) => {
                return (
                  <li
                    className={classes.steps}
                    key={key}
                    style={{ width: this.state.width }}
                  >
                    <a
                      href="#"
                      className={classes.stepsAnchor}
                      onClick={(e) => e.preventDefault()}
                    >
                      {prop.stepName}
                    </a>
                  </li>
                );
              })}
            </ul>
            <div
              className={classes.movingTab + " " + classes[color]}
              style={this.state.movingTabStyle}
            >
              {steps[this.state.currentStep].stepName}
            </div>
          </div>

          <div className={classes.content}>
            {steps.map((prop, key) => {
              const stepContentClasses = cx({
                [classes.stepContentActive]: this.state.currentStep === key,
                [classes.stepContent]: this.state.currentStep !== key,
              });
              return (
                <div className={stepContentClasses} key={key}>
                  <prop.stepComponent
                    ref={(node) => (this[prop.stepId] = node)}
                    allStates={this.state.allStates}
                  />
                </div>
              );
            })}
          </div>

          <div className={classes.footer}>
            <div className={classes.left}>
              {this.state.previousButton && (
                <Button onClick={() => this.previousButtonClick()}>
                  {this.props.previousButtonText}
                </Button>
              )}
            </div>
            <div className={classes.right}>
              {this.state.nextButton && (
                <Button color="rose" onClick={() => this.nextButtonClick()}>
                  {this.props.nextButtonText}
                </Button>
              )}
              {this.state.finishButton && (
                <Button color="rose" onClick={() => this.finishButtonClick()}>
                  {this.props.finishButtonText}
                </Button>
              )}
            </div>
            <div className={classes.clearfix} />
          </div>
        </Card>
      </div>
    );
  }
}

Wizard.defaultProps = {
  color: "rose",
  title: "Here should go your title",
  subtitle: "And this would be your subtitle",
  previousButtonText: "Previous",
  nextButtonText: "Next",
  finishButtonText: "Finish",
};

Wizard.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepName: PropTypes.string.isRequired,
      stepComponent: PropTypes.object.isRequired,
      stepId: PropTypes.string.isRequired,
    })
  ).isRequired,
  color: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose",
    "blue",
  ]),
};

export default withStyles(wizardStyle)(withRouter(Wizard));
